<template lang="pug">
transition(name='loading')
  #loading 


</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ProgressBar from 'src/components/_utils/ProgressBar'
import AnimatedNumber from 'src/components/_utils/AnimatedNumber'
import AssetService from 'src/services/AssetService' 
import ImageService from 'src/services/ImageService'
import { TweenMax } from 'gsap'

export default {

  name: 'loading',

  components: {
    ProgressBar,
    AnimatedNumber,
  },

  data() {
    return {
      progress: {
        assets: 0,
        media: 0,
        sounds: 0,
      },
      startTime: Date.now(),
      updateTime: 100,
      minTime: 1000,
      tweenObj: {
        ratio: 0,
        close: 0
      }
    }
  },

  computed: {
    ...mapState('browser', ['isMobile']),
    ...mapState('app', [
      'loading',
      'debug',
      'route',
      'logged_in'
    ]),
    arrowStyle() { }
  },

  mounted() {
  
    AssetService.on(AssetService.Events.GROUP_PROGRESS, this.onAssetsProgress) 
    ImageService.on(ImageService.Events.GROUP_COMPLETED, this.onGroupComplete)  
 
    this.tl = new TimelineMax(); 
    this.tl.to(this.tweenObj, 5, {ratio:1,  repeat:-1, ease: 'Quad.easeInOut'})
    this.tl.play(); 
   
  },

  beforeDestroy() {
    AssetService.off(AssetService.Events.GROUP_PROGRESS, this.onAssetsProgress) 
    ImageService.off(ImageService.Events.GROUP_COMPLETED, this.onGroupComplete) 
 
  },

  methods: {

    ...mapMutations('app', ['setLoadProgress', 'setLoadComplete']),

    onAssetsProgress(data) {
      if(data.groupId === 'main'){ 
        this.setLoadProgress(data.progress) 
      }
    },

    onGroupComplete(group) {
      if(group === 'main'){
        this.next();
      }
    }, 
 

    next() {

      this.setLoadProgress(1);
      this.setLoadComplete();
      
      let name = this.isMobile ? 'swipeup' : 'intro';
      TweenMax.to(this.$el, 2, { 
        ease: 'Expo.easeIn',
        opacity: 0,
        onComplete: () => {
          this.$router.replace({ name: name }); 
          //this.tl.pause(); 
        }
      }); 
    }
  },

  watch: {}
}
</script>

<style lang="sass" scoped>

@import "src/styles/common.sass"

#loading

  +full()
  +flex-center()
 
 


</style>
